import { useCustomQuery } from '../../../../../hooks/query';
import { GET_NON_NATIONAL_EXAM_LIST, GET_REGISTRATION_REPORT_EXAM_LEVEL } from './keys';
import { getNonNationalExamList, getRegistrationReportExamLevel } from '../api-services/api';
import { NonNationalExamList, RegistrationReportExamList } from '../../model';

export const useGetRegistrationReportExamLevel = () =>
  useCustomQuery<RegistrationReportExamList>(GET_REGISTRATION_REPORT_EXAM_LEVEL, () =>
    getRegistrationReportExamLevel().then((res) => res.data)
  );

export const useGetNonNationalExamList = () =>
  useCustomQuery<NonNationalExamList>(GET_NON_NATIONAL_EXAM_LIST, () =>
    getNonNationalExamList().then((res) => res.data)
  );
